const MAX_RETRIES = 3;
const RETRY_DELAY = 2000; // 2 seconds delay between retries

const retryWithBackoff = async (fn, args = [], maxRetries = MAX_RETRIES, delay = RETRY_DELAY) => {
    let attempt = 0;
    while (attempt < maxRetries) {
        try {
            return await fn(...args); // Attempt to execute the function
        } catch (error) {
            attempt++;
            console.warn(`Attempt ${attempt}/${maxRetries} failed:`, error);

            if (attempt === maxRetries) {
                console.error("Max retries reached. Aborting...");
                throw error; // Propagate the error after max retries
            }

            await new Promise(resolve => setTimeout(resolve, attempt * delay)); // Exponential backoff
        }
    }
};

export {retryWithBackoff}
